/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Vote_FailedInputs */

const en_us2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your vote could not be saved. Try again.`)
};

const pt_br2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para registrar seu voto. Tente de novo.`)
};

const es_419_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo guardar tu voto. Intenta de nuevo.`)
};

const pt_pt2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível registar o teu voto. Tenta outra vez.`)
};

const fr_fr2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'enregistrer ton vote. Réessaie.`)
};

const de_de2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stimme nicht gespeichert. Versuch es noch mal.`)
};

const it_it2_community_vote_failed = /** @type {(inputs: Community_Vote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile salvare il tuo voto. Riprova.`)
};

/**
* | output |
* | --- |
* | "Your vote could not be saved. Try again." |
*
* @param {Community_Vote_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_vote_failed = /** @type {((inputs?: Community_Vote_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Vote_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_vote_failed(inputs)
	if (locale === "es-419") return es_419_community_vote_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_community_vote_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_community_vote_failed(inputs)
	if (locale === "de-DE") return de_de2_community_vote_failed(inputs)
	if (locale === "it-IT") return it_it2_community_vote_failed(inputs)
	return en_us2_community_vote_failed(inputs)
});
export { community_vote_failed as "community.vote_failed" }